import { defaultLocale, localeOptions } from "@constants/defaultValues";

  export const getCurrentLanguage = () => {
    let language = defaultLocale;
    const currentLanguage = localeOptions.filter((x) => x.id === localStorage.getItem('currentLanguage')).length > 0;

    try {
      const getCurrentLanguageLS = localStorage.getItem('currentLanguage');
      language = getCurrentLanguageLS && currentLanguage ? getCurrentLanguageLS : defaultLocale;
    } catch (error) {
      console.info('>>>>: src/helpers : getCurrentLanguage -> error', error);
      language = defaultLocale;
    }
    return language;
  };

  export const setCurrentLanguage = (locale) => {
    try {
      localStorage.setItem('currentLanguage', locale);
    } catch (error) {
      console.info('>>>>: src/helpers : setCurrentLanguage -> error', error);
    }
  };

  export function formatDate(date, onlyDate = false) {
    let _formated = onlyDate ? '--/--/--' : '--/--/-- 00:00';

    if (date) {
        const localDate = new Date(date + 'T00:00:00');
        _formated = onlyDate ? localDate.toLocaleDateString() : localDate.toLocaleString();
    }
    return _formated.replace(',', '');
}

  export function changePeriod(val) {
    let _start, _end;

    switch (val) {
      //Today
      case 'hoje':
        _start = new Date().toLocaleDateString();
        _end = new Date().toLocaleDateString();
        break;
      //Yesterday
      case 'ontem':
        _start = new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //Daybeforeyesterday
      case 'anteontem':
        _start = new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //LastSevenDays
      case 'semana':
        _start = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().substr(0, 10);
        break;
      //LastFifteenDays
      case 'quinzena':
        _start = new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //LastThirtyDays
      case 'mes':
        _start = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //Last2Months
      case 'doisMeses':
        _start = new Date(new Date().getTime() - 60 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //Last3Months
      case 'tresMeses':
        _start = new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //Last6Months
      case 'seisMeses':
        _start = new Date(new Date().getTime() - 183 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //LastYear
      case 'ano':
        _start = new Date(new Date().getTime() - 365 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;
      //All
      case 'todos':
        _start = '';
        _end = '';
        break;
      //Other
      case 'outro':
        _start = new Date().toISOString().slice(0, 10);
        _end = new Date().toISOString().slice(0, 10);
        break;

      default:
        break;
    }

    const payload = {
      start: _start,
      end: _end,
    };
    return payload;
  }

  export function getDate(periodo) {
    let dtinicial = new Date();
    let dtfinal = new Date();

    switch (periodo) {
      case 'hoje':
        dtinicial = new Date();
        dtfinal = new Date();
        break;
      case 'ontem':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 1));
        dtfinal = new Date();
        break;
      case 'anteontem':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 2));
        dtfinal = new Date();
        break;
      case 'semana':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 7));
        dtfinal = new Date();
        break;
      case 'quinzena':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 15));
        dtfinal = new Date();
        break;
      case 'mes':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 1));
        dtfinal = new Date();
        break;
      case 'doisMeses':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 2));
        dtfinal = new Date();
        break;
      case 'tresMeses':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 3));
        dtfinal = new Date();
        break;
      case 'seisMeses':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 6));
        dtfinal = new Date();
        break;
      case 'ano':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 12));
        dtfinal = new Date();
        break;
      default:
        dtinicial = new Date();
        dtfinal = new Date();
    }

    const payload = {
      dtinicial,
      dtfinal,
    };

    return payload;
  }

  export function obterListagemDePeriodos(intl) {
		const periodos = [
		  { value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` },
		  { value: 'ontem', label: `${intl.formatMessage({ id: "period.yesterday" })}` },
		  { value: 'anteontem', label: `${intl.formatMessage({ id: "period.daybeforeyesterday" })}` },
		  { value: 'semana', label: `${intl.formatMessage({ id: "period.has1week" })}` },
		  { value: 'quinzena', label: `${intl.formatMessage({ id: "period.has15days" })}` },
		  { value: 'mes', label: `${intl.formatMessage({ id: "period.has1month" })}` },
		  { value: 'doisMeses', label: `${intl.formatMessage({ id: "period.has2months" })}` },
		  { value: 'tresMeses', label: `${intl.formatMessage({ id: "period.has3months" })}` },
		  { value: 'seisMeses', label: `${intl.formatMessage({ id: "period.has6months" })}` },
		  { value: 'ano', label: `${intl.formatMessage({ id: "period.has1year" })}` },
		  { value: 'outro', label: `${intl.formatMessage({ id: "period.other" })}` }
		];

		return periodos;
	}

  export function validarData(dataInicial, dataFinal, intl, commonActions) {
    const tipoAlerta = 'alerta';

		if (dataInicial === undefined || dataInicial === '')
		{
			commonActions.showAlerta(tipoAlerta, `${intl.formatMessage({id: 'dashboards.general.informValidStartDate'})}`, 2000);
			return false;
		}

		if (dataFinal === undefined || dataFinal === '')
		{
			commonActions.showAlerta(tipoAlerta, `${intl.formatMessage({id: 'dashboards.general.informValidEndDate'})}`, 2000);
			return false;
		}

		var timeDataInicial = new Date(dataInicial).getTime();
		var timeDataFinal = new Date(dataFinal).getTime();

		if (timeDataInicial > timeDataFinal)
		{
			commonActions.showAlerta(tipoAlerta, `${intl.formatMessage({id: 'dashboards.general.startDateGreaterEndDate'})}`, 2000);
			return false;
		}

		var msDoDia = 1000 * 60 * 60 * 24;
		var msDiferenca = Math.abs(timeDataFinal - timeDataInicial);
		var diferencaEmDias = Math.round(msDiferenca / msDoDia);

		if (diferencaEmDias > 366)
		{
			commonActions.showAlerta(tipoAlerta, `${intl.formatMessage({ id: "dashboards.general.consultationGreater1Year" })}`, 2000);
			return false;
		}

		return true;
	}


// WEBPACK FOOTER //
// ./src/helpers/index.js